import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-canvas-chunk-dialog',
  standalone: true,
  imports: [TranslateModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule, MatIconModule, FormsModule],
  template: `
    <div class="standard-dialog">
      <div class="header" mat-dialog-title>
        <div class="title-section">
          <h2>{{ 'CreateChunk.CanvasChunk' | translate }}</h2>
          <p class="subtitle">{{ 'CreateChunk.CanvasSubtitle' | translate }}</p>
        </div>
        <button mat-icon-button (click)="dialogRef.close()" class="close-btn">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <mat-dialog-content class="form-content pt-4">
        <div class="w-100 mb-3">
          <mat-label class="form-label mb-1">{{ 'CreateChunk.CanvasTitle' | translate }}</mat-label>
          <mat-form-field subscriptSizing="dynamic" appearance="fill" class="soft-input w-100">
            <input matInput [(ngModel)]="title" (keydown.enter)="submit()" [placeholder]="'CreateChunk.CanvasTitlePlaceholder' | translate" autofocus />
          </mat-form-field>
        </div>
      </mat-dialog-content>

      <mat-dialog-actions class="footer">
        <div class="right-actions ml-auto">
          <button mat-button (click)="dialogRef.close()">{{ 'Global.Cancel' | translate }}</button>
          <button mat-flat-button color="primary" (click)="submit()" [disabled]="!title.trim()">{{ 'Global.Insert' | translate }}</button>
        </div>
      </mat-dialog-actions>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CanvasChunkDialogComponent {
  dialogRef = inject(MatDialogRef<CanvasChunkDialogComponent>);
  title = '';

  submit() {
    if (!this.title.trim()) return;
    this.dialogRef.close({ title: this.title.trim() });
  }
}
